export const API_ASSET_MANAGER_PATH     = "assetmanager";
export const API_ACCOUNT_IDS_PATH       = "account_ids";
export const API_ADVISOR_PATH           = "advisor";
